<template>
        <div class="alertBox">
          <div class="alertBox_con">
                <div class="paymentdetail_div1">
                  <span class="title">{{title}}</span>
                  <div class="msg">{{Message}}</div>
                </div>
                <div class="paymentdetail_div2">
                  <span class="f1" @click="isShowRefruct">取消</span>
                    <a v-if='isCall' class="f2" :href="`tel:${callNum}`">确认</a>
                  <span v-else class="f2" @click="isShowAgree">确认</span>
                
                </div>

          </div>

        </div>
    
</template>
<script>

export default {
    name: "alertbox",
    props:{
            isCall:{
                type: Boolean,
                default:false
            },
            callNum:{
                type: [String,Number],
                default:''
            },
            isshowAlert: {
                type: Boolean,
                default:false
            },
            title: {
                type: String,
                default:'温馨提示'
            },
            Message:{
                type :String,
                default:''
            }
        },

  data() {

    return {

      isShowDialogs: true

    };

  },

  methods: {

    isShowRefruct() {
      this.$emit("replaceChecked", "replace");

    },

    isShowAgree() {

      this.isShowDialogs = false;

      this.$emit("sureChecked", this.Message);

    }

  },

//   watch: {
//     isshowAlert() {
//       this.isShowDialogs = this.isshowAlert;

//     }

//   }

};

</script>
<style scoped>
.alertBox{
    left:0;
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    z-index:33333;
    background-color:rgba(0,0,0,0.6);
}
.alertBox_con{
    width:325px;
    background-color:#ffffff;
    height:150px;
    border-radius:5px;
    position:absolute;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
}
.paymentdetail_div1{
    height:99.5px;
    text-align:center;
    color:#333;
    display:flex;
    flex-direction:column;
    align-items:center;
    padding-top:14.5px;
    box-sizing:border-box;
}
.paymentdetail_div1 .msg{
    font-size:15px;
    margin-top:14px;
}
.paymentdetail_div1 .title{
    font-size:20px;
}
.paymentdetail_div2{
    display:flex;
    justify-content:space-between;
    border-top:1px solid #C3C3C3;
    font-size:16px;
}
.paymentdetail_div2 .f1{
    height:50px;
    line-height:50px;
    color:#5DD7CC;
    text-align:center;
    width:50%;
    border-right:1px solid #C3C3C3;
    color:#666666;
    box-sizing:border-box;
}
.paymentdetail_div2 .f2{
    height:50px;
    line-height:50px;
    color:#5DD7CC;
    text-align:center;
    width:50%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/alertBox.vue